import { ref, computed } from 'vue'

export const useStickyTabs = () => {
  const activeSection = useState<string>(
    'pdp-active-section',
    () => ''
  )

  const expandedSections = useState<
    Record<string, boolean>
  >(
    'pdp-expanded-sections',
    () => ({})
  )
const scrollToSection = async (
  id: string,
  tabElement?: HTMLElement | null
) => {
  if (tabElement  &&  window.innerWidth < 1024) {
    tabElement.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    })
  }
  expandedSections.value[id] = true
  activeSection.value = id

  await nextTick()

  requestAnimationFrame(() => {
    const element =
      document.getElementById(id)

    if (!element) return
    const stickyOffset =
      window.innerWidth >= 1024
        ? 140
        : 220
    const top =
      element.getBoundingClientRect().top +
      window.scrollY -
      stickyOffset

    window.scrollTo({
      top,
      behavior: 'smooth'
    })
  })
}
const updateActiveSection = (
  sectionIds: string[]
) => {
  if (window.scrollY < 80) {
    activeSection.value = ''
    return
  }

  const triggerLine =
    window.innerWidth >= 1024
      ? 220
      : 260

  let matchedSection = ''

  for (const id of sectionIds) {
    const element =
      document.getElementById(id)

    if (!element) continue

    const rect =
      element.getBoundingClientRect()

    if (
      rect.top <= triggerLine &&
      rect.bottom > triggerLine
    ) {
      matchedSection = id
    }
  }

  activeSection.value =
    matchedSection
}

  return {
    activeSection,
    expandedSections,
    scrollToSection,
    updateActiveSection
  }
}
